module.exports = "/_next/static/files/572bfe1c2e5b21f499154f038c49ff2b.png";